import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=35a2bc09&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=35a2bc09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2bc09",
  null
  
)

export default component.exports